// Addtional label for variant width option on pdp

(function(){
  const changeAddtionalWidthOptionLabel = () => {
    const additionalLable = document.querySelector('.addtional-width-label')
    const selectedInput = document.querySelector('[data-additional-label]:checked')
    if(additionalLable) {
      additionalLable.textContent = selectedInput.dataset.additionalLabel
    }
  }
  document.querySelectorAll('[data-additional-label]').forEach( input => {
    input.addEventListener('change', () => {
      changeAddtionalWidthOptionLabel()
    })
  })
  document.addEventListener('DOMContentLoaded', () => {
    changeAddtionalWidthOptionLabel()
  })
})()


